module.exports = __webpack_public_path__ + "images/emoji/cloud.d24eeb47704038fd34bd.png";